import { useAppContext } from './AppContext';

export const useAuth = () => {
    const { auth } = useAppContext();
    return auth;
}